import * as yup from 'yup'
export default () => {
  return yup.object().shape({
    telefono: yup
      .string()
      .required('Este campo es obligatorio')
      .matches(/^[0-9]+$/, 'El telefono solo lleva digitos')
      .min(8, 'Los telefonos en Cuba tienen 8 digitos')
      .max(8, 'Los telefonos en Cuba tienen 8 digitos'),
    cantidad: yup
      .string()
      .required('Este campo es obligado')
      .matches(/^[0-9]+$/gi, 'Must be a Number')
      .required('Required'),
    nombre: yup.string().required('Este campo es obligado')
  })
}
